import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompetitorRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 3.976a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm0 14.5a8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8 8 8 0 0 0 8 8Zm-5-8h3A2 2 0 0 1 9.14 8.67l-1.503-2.6A4.997 4.997 0 0 0 5 10.476Zm3.866 1.647-1.5 2.603c.765.475 1.668.75 2.634.75s1.869-.275 2.634-.75l-1.503-2.603a1.992 1.992 0 0 1-2.266 0ZM12 10.476h3a4.997 4.997 0 0 0-2.637-4.406l-1.504 2.603A1.991 1.991 0 0 1 12 10.476Zm-2 1a.999.999 0 1 0 0-2 .999.999 0 1 0 0 2Z" })
});
export default SvgCompetitorRegularIcon;
